// 环评审核
<template>
  <div class="mapwrap-eia" v-if="isRefresh">
    <div>
      <el-tabs class="pollutionSrcsTabs" v-model="tabType" v-if="tabData.length>1" @tab-click="handleRefresh()" stretch>
        <el-tab-pane v-for="(tabDataItem, tabDataIndex) in tabData" :key="tabDataIndex"
          :label="tabDataItem.tabTitle" :name="tabDataItem.tabIndex"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- table -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'table'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="addRow">提交环评</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" @click="addTerm">新增规则</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'table'">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <!-- <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th> -->
          <th class="cell thtitle" v-for="(th, thi) in tableNamesS" :key="thi">{{th}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{tri+1}}</td>
          <!-- <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi"> -->
          <td class="cell tdcell" v-for="(td, tdi) in rowItemsS" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button type="text" size="mini" @click="showDetails(tr)">详情</el-button><br>
            <el-button type="text" size="mini" @click="editRow(tr)">检查记录</el-button><br>
            <el-button type="text" size="mini" @click="showProtectionCheck(tr)">保护目标</el-button><br>
            <el-button type="text" size="mini" @click="deleteRow(tr)">删除</el-button>
            <!-- <el-button type="text" size="mini" @click="makeSure(item)">上传文件</el-button> -->
          </td>
        </tr>
      </table>
    </div>
    <!-- multiform -->
    <!-- <div class="searchInput" v-if="tabDataCrt.tabType === 'multiform'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="editForm()">编辑</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" @click="saveForm()">保存</el-button>
    </div> -->
    <div class="mainTable" v-if="tabDataCrt.tabType === 'multiform'">
      <table class="listTable" width="100%" border="1" align="center">
        <!-- <tr>
          <th class="cell thtitle" width="25%" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
        </tr> -->
        <tr v-for="(tr, tri) in tabDataCrt.multiformData" :key="tri">
          <td class="cell tdcell" width="25%" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tabDataCrt.editable && !tr.editFlag && td !== 'name'" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <nut-dialog
      :closeOnClickModal="false"
      @close="jindu = false"
      v-if="jindu"
      :visible="jindu"
      title="下载进度"
      width="200px"
      :noFooter="true">
      <progress :value="percentage" max="100"></progress>{{ percentage }}%
      <p>{{ text1 }}</p>
    </nut-dialog>
    <nut-dialog
      :closeOnClickModal="false"
      @close="importFlag = false"
      v-if="importFlag"
      :visible="importFlag"
      title="导入"
      :noFooter="true">
      <eiaTableImport
        ref="uploadRef"
        :btnName="'导入'"
        :uploadMethod="'cdSummaryTableUpload'"
        :acceptList="'*'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload"
        @closeIF="closeIF">
      </eiaTableImport>
    </nut-dialog>
    <nut-dialog
      @close="wordInfo = false"
      :closeOnClickModal="false"
      v-if="wordInfo"
      :visible="wordInfo"
      title="文字说明"
      :noFooter="false"
      :onOkBtn="determine"
      :onCancelBtn="closeWI"
      cancelBtnTxt="关闭">
      <div>
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容，例：根据环办环评〔2020〕33号《建设项目环境影响报告表编制技术指南（污染影响类）（试行）》，如果项目排放废气含有甲醛且厂界外 500 米范围内有环境空气保护目标，环评表就要做大气专项评价"
          v-model="textarea">
        </el-input>
      </div>
      <!-- <div align="center">
        <el-button type="primary" size="small" @click="determine">确定</el-button>
      </div> -->
    </nut-dialog>
    <nut-dialog
      @close="showDetailsDialogFlag = false"
      v-if="showDetailsDialogFlag"
      :visible="showDetailsDialogFlag"
      title="详情"
      height="1000px"
      :noFooter="true">
      <div class="details-dialog-main">
        <table>
          <template v-for="(title, tindex) in tableNamesD">
            <tr :key="tindex*2">
              <th>{{ title }}</th>
            </tr>
            <tr :key="tindex*2+1">
              <td>{{ detailsRow[rowItemsD[tindex]] }}</td>
            </tr>
          </template>
        </table>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showProtectionCheckDialogFlag = false"
      v-if="showProtectionCheckDialogFlag"
      :visible="showProtectionCheckDialogFlag"
      title="保护目标"
      height="1000px"
      :noFooter="true">
      <div class="protection-dialog-main-forApp">
        <div class="pd-left">
          <protection-map ref="protectionMap" :protectionCenter="protectionCenter"></protection-map>
        </div>
        <div class="pd-right">
          <table>
            <tr>
              <th v-for="(cell, sindex) in protectionTable.title" :key="sindex">{{ cell }}</th>
            </tr>
            <tr v-for="(line, index) in protectionTable.table" :key="index">
              <td v-for="(cell, sindex) in line" :key="sindex" align="center">{{ cell }}</td>
            </tr>
          </table>
        </div>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../api/index'
import eiaTableImport from '../pages/eiaTableImport.vue'
import protectionMap from '../../src/H5pages/protectionMap'
export default {
  data () {
    return {
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '环评审核',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '文件名称',
            '项目名称',
            '建设单位',
            '环评类别',
            '行业类别'
          ],
          rowItems: [
            'fileName',
            'constructionUnits',
            'companyName',
            'constructionProject',
            'nationalEconomy'
          ],
          api: {
            add: 'cdSummaryTableAdd',
            enquiry: 'cdSummaryTableEnquiry',
            update: 'cdSummaryTableUpdate',
            delete: 'cdSummaryTableDelete',
            extraParam: {
              category: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
      ],
      tabDataCrt: {},
      tableNamesS: [
        '文件名称',
        '项目名称'
        // '建设单位',
        // '环评类别',
        // '行业类别'
      ],
      rowItemsS: [
        'fileName',
        'constructionUnits'
        // 'companyName',
        // 'constructionProject',
        // 'nationalEconomy'
      ],
      tableNamesD: [
        '文件名称',
        '项目名称',
        '建设单位',
        '环评类别',
        '行业类别'
      ],
      rowItemsD: [
        'fileName',
        'constructionUnits',
        'companyName',
        'constructionProject',
        'nationalEconomy'
      ],
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true,
      jindu: false,
      percentage: 10,
      text1: '',
      importFlag: false,
      extaParam: {},
      wordInfo: false,
      textarea: '',
      detailsRow: {},
      showDetailsDialogFlag: false,
      showProtectionCheckDialogFlag: false,
      protectionCenter: '',
      protectionTable: {
        title: ['title1', 'title2', 'title3', 'title4', 'title5'],
        table: [
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5']
        ]
      }
    }
  },
  mounted () {
    api.login({
      phoneNumber: this.$route.query.phoneNumber,
      password: this.$route.query.password
    }).then(res => {
      if (res.code === 200) {
        console.log(res.data)
        sessionStorage.setItem('qs_phone', this.$route.query.phoneNumber)
        sessionStorage.setItem('qs_token', res.data.token)
        sessionStorage.setItem('qs_user_name', res.data.name)
        this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
        this.getTabData()
        console.log(sessionStorage.getItem('qs_phone') || null)
      }
    })
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              jsonData: item.jsonData,
              longitude: item.longitude,
              latitude: item.latitude,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      console.log(this.tabType)
      this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTabData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    closeIF () {
      this.importFlag = false
    },
    addRow () {
      this.importFlag = true
      // var bianliang = setInterval(() => {
      //   this.percentage = this.percentage + 1
      //   if (this.percentage >= 99) {
      //     clearInterval(bianliang)
      //   }
      // }, 1000)
    },
    handleSuccess () {
      this.$toast.text('上传成功')
      this.getTabData()
    },
    checkUpload () {
      this.$refs.uploadRef.doUpload()
    },
    closeWI () {
      this.wordInfo = false
    },
    addTerm () {
      this.wordInfo = true
    },
    determine () {
      api.cdSummaryTableAdd({
        textarea: this.textarea
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$toast.text('确定成功')
          // this.$message({
          //   message: '确定成功',
          //   type: 'success'
          // })
        }
      })
    },
    editRow (row) {
      // row.editFlag = true
      this.percentage = 0
      this.jindu = true
      var bianliang = setInterval(() => {
        this.percentage = this.percentage + 1
        if (this.percentage >= 99) {
          clearInterval(bianliang)
        }
      }, 1000)
      api.cdSummaryTableDownload({
        id: row.id
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          window.open(res.data)
          this.percentage = 100
          clearInterval(bianliang)
          setTimeout(() => {
            this.jindu = false
          }, 1000)
        } else {
          clearInterval(bianliang)
          this.text1 = res.message
        }
        // if (res.code === 40001) {
        //   this.jindu = false
        // }
      })
    },
    saveRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        var savePusher = {
          id: row.id,
          ...this.tabDataCrt.api.extraParam
        }
        this.tabDataCrt.rowItems.forEach(rowItem => {
          console.log(row, rowItem, row[rowItem])
          savePusher[rowItem] = row[rowItem] || ''
        })
        api[this.tabDataCrt.api.update](savePusher).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    showDetails (row) {
      console.log(row)
      this.detailsRow = row
      this.showDetailsDialogFlag = true
    },
    showProtectionCheck (row) {
      console.log(row)
      if (row.jsonData) {
        this.showProtectionCheckDialogFlag = true
        this.protectionCenter = [Number(row.longitude), Number(row.latitude)]
        this.protectionTable = JSON.parse(row.jsonData)
        setTimeout(() => {
          this.$refs.protectionMap.addGraphics()
        }, 3000)
      } else {
        this.$toast.text('该项目没有保护目标')
      }
    }
  },
  components: {
    eiaTableImport,
    protectionMap
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap-eia{
  z-index: 0;
  height: 100%;
  overflow-y: auto;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
  .cell{
    border: 1px #ccc solid;
    text-align: center;
  }
  .thtitle{
    background-color: #fafafa;
    line-height: 24px;
  }
  .tdcell{
    background-color: #fff;
    line-height: 32px;
    padding: 2px;
    .el-input__inner{
      height: 28px!important;
    }
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
.details-dialog-main{
  table{
    width: 100%;
    height: 100%;
    border-top: 1px #000 solid;
    border-left: 1px #000 solid;
    th{
      color: #000;
    }
    th, td{
      padding: 16px 0;
      border-bottom: 1px #000 solid;
      border-right: 1px #000 solid;
    }
  }
}
.protection-dialog-main-forApp{
  // display: flex;
  justify-content: center;
  .pd-left{
    // width: 50vw;
    // height: calc(66vh - 80px);
    height: 50vh;
    padding: 2px;
  }
  .pd-right{
    // width: 50vw;
    // height: calc(66vh - 80px);
    height: 50vh;
    padding: 2px;
    table{
      width: 100%;
      height: 100%;
      border-top: 1px #000 solid;
      border-left: 1px #000 solid;
      th{
        color: #000;
      }
      th, td{
        padding: 16px 0;
        border-bottom: 1px #000 solid;
        border-right: 1px #000 solid;
      }
    }
  }
}
</style>
